import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'
import React from 'react'

interface ComponentProps {
  DeleteConfirmOpen: boolean
  HandleCancelDelete: () => void
  HandleDeleteRow: () => void
}

export const ModalConfirmDelete: React.FC<ComponentProps> = ({
  DeleteConfirmOpen,
  HandleCancelDelete,
  HandleDeleteRow
}) => {
  return (
    <Dialog
      open={DeleteConfirmOpen}
      onClose={HandleCancelDelete}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>Confirmar eliminación</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          ¿Estás seguro de que deseas eliminar este registro? Esta acción no se
          puede deshacer.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={HandleCancelDelete} color='default'>
          Cancelar
        </Button>
        <Button onClick={HandleDeleteRow} color='secondary' autoFocus>
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
